// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"128":"0535af0d","215":"d71b28f6","279":"7f58df8c","971":"a1766743"}[chunkId] + ".chunk.css";
};